// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"7043dfe4","377":"d75f97b1","487":"3e92fb37","601":"b49cec84"}[chunkId] + ".chunk.js";
};